export default "__VITE_ASSET__CKwJJEoM__"